var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbonProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8188 34.4443C15.1783 34.4443 14.659 34.9727 14.659 35.6243C14.659 36.276 15.1783 36.8043 15.8188 36.8043H15.8195C16.46 36.8043 16.979 36.276 16.979 35.6243C16.979 34.9727 16.4593 34.4443 15.8188 34.4443Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9722 7.57696L25.8482 6.15527L34.4577 28.0324C35.1708 29.8445 34.3019 31.9091 32.5208 32.6346L20.8232 37.3996L34.4141 38.9929C34.4584 38.9981 34.5027 39.0007 34.547 39.0007C34.8074 39.0007 35.0617 38.9114 35.2678 38.7451C35.5088 38.5506 35.664 38.2666 35.6991 37.9557L38.9916 8.88418C39.0649 8.23684 38.6085 7.65157 37.9722 7.57696Z",
    fill: "#7DC82F",
    fillOpacity: 0.303731
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.305 28.9091L21.6135 1.74142C21.4992 1.45094 21.2761 1.21845 20.9934 1.09529C20.7106 0.97206 20.3912 0.968209 20.1057 1.08457L1.72904 8.57056C1.13439 8.81287 0.845308 9.49962 1.0834 10.1046L11.7749 37.2724C11.8893 37.563 12.1124 37.7954 12.3951 37.9185C12.5408 37.982 12.6962 38.0137 12.8516 38.0137C12.998 38.0137 13.1444 37.9856 13.2829 37.9291L16.2264 36.7295C16.2344 36.7264 16.2424 36.7233 16.2504 36.72L31.6594 30.4432C32.2541 30.2009 32.5431 29.5141 32.305 28.9091Z",
    fill: "#7DC82F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1885 20.709L11.971 19.9452L15.5711 14.0048L16.7886 14.7686L13.1885 20.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6006 20.9814L15.2409 18.8739L16.0865 17.4787L19.4462 19.5862L18.6006 20.9814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6943 18.8525L10.4768 18.0888L13.2574 13.5007L14.475 14.2644L11.6943 18.8525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5537 16.4111L9.50064 15.7505L10.7659 13.6628L11.819 14.3234L10.5537 16.4111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1279 24.4355L17.9104 23.6718L21.5106 17.7314L22.7281 18.4951L19.1279 24.4355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4287 24.9609L20.2112 24.1972L22.9918 19.6091L24.2093 20.3728L21.4287 24.9609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9141 24.793L22.8676 24.1365L24.1329 22.0488L25.1793 22.7052L23.9141 24.793Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9053,
    height: 13.6928,
    fill: "white",
    transform: "matrix(-0.227039 -0.973886 0.972099 -0.23457 12.2637 27.6035)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbonProfile);
export default __webpack_public_path__ + "static/media/abonProfile.241ee64c6c8e78529053323ae739bee8.svg";
export { ForwardRef as ReactComponent };